<template>
  <div class="map-panel-wrapper">
    <div v-if="sticky" class="map-sticky">
      <section class="content-panel map-panel">
        <div class="panel-header">
          <h5 class="panel-title mb-1">{{ title }}</h5>
          <p class="panel-description mb-0">{{ description }}</p>
        </div>
        <div ref="mapContainer" class="map-container"></div>
      </section>
    </div>
    <section v-else class="content-panel map-panel">
      <div class="panel-header">
        <h5 class="panel-title mb-1">{{ title }}</h5>
        <p class="panel-description mb-0">{{ description }}</p>
      </div>
      <div ref="mapContainer" class="map-container"></div>
    </section>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import {OSM} from "@/stores/constants";
import {DEFAULT_MAP_VIEW, DEFAULT_MAP_ZOOM} from "@/scripts/locationSearch";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  name: "LeafletLocationMap",
  props: {
    title: {
      type: String,
      default: "Kartenansicht",
    },
    description: {
      type: String,
      default: "",
    },
    lat: {
      type: Number,
      default: null,
    },
    lon: {
      type: Number,
      default: null,
    },
    sticky: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      map: null,
      marker: null,
    }
  },
  mounted() {
    this.map = L.map(this.$refs.mapContainer).setView(DEFAULT_MAP_VIEW, DEFAULT_MAP_ZOOM);
    L.tileLayer(OSM.tileUrl, {
      attribution: OSM.attribution,
    }).addTo(this.map);
    this.syncMarker();
    this.invalidateMapSize();
  },
  beforeUnmount() {
    const map = this.map

    this.marker = null
    this.map = null

    if (map) {
      map.remove();
    }
  },
  watch: {
    lat() {
      this.syncMarker()
    },
    lon() {
      this.syncMarker()
    },
  },
  methods: {
    hasUsableMap() {
      return Boolean(
        this.map
        && this.$refs.mapContainer?.isConnected
        && this.map._mapPane
      )
    },
    invalidateMapSize() {
      this.$nextTick(() => {
        if (this.hasUsableMap()) {
          this.map.invalidateSize();
        }
      });
    },
    syncMarker() {
      if (!this.hasUsableMap()) {
        return
      }

      const lat = Number(this.lat)
      const lon = Number(this.lon)
      const hasCoords = Number.isFinite(lat) && Number.isFinite(lon)

      if (!hasCoords) {
        if (this.marker) {
          this.map.removeLayer(this.marker)
          this.marker = null
        }
        return
      }

      if (!this.marker) {
        this.marker = L.marker([lat, lon]).addTo(this.map);
      } else {
        this.marker.setLatLng([lat, lon])
      }

      this.map.setView([lat, lon], 15);
      this.invalidateMapSize();
    },
  },
}
</script>

<style scoped lang="scss">
.map-panel-wrapper {
  height: 100%;

  @media (min-width: 992px) {
    align-self: stretch;
  }
}

.map-panel {
  border: 1px solid #dee2e6;
  background: #ffffff;
  padding: 1rem;
}

.panel-header {
  margin-bottom: 1rem;
}

.panel-title {
  font-size: 1rem;
  font-weight: 600;
  color: #212529;
}

.panel-description {
  color: #6c757d;
  font-size: 0.95rem;
  line-height: 1.45;
}

.map-container {
  width: 100%;
  height: 500px;
}

@media (min-width: 992px) {
  .map-sticky {
    position: -webkit-sticky;
    position: sticky;
    top: calc(var(--navbar-height, 55px) + 1rem);
    z-index: 2;
  }
}
</style>
